<template lang="pug">
#nova-operacao-cda-wa
    BaseHeader(titulo='Nova Operação CDA-WA', :voltarPara='true')

    .view-container-base-header
        .nova-operacao-cda-wa__preenchimento-em-massa
            h2.font-weight-bold Preenchimento em massa
            el-card(:body-style='{ padding: "20px" }')
                p Para cadastrar os imóveis à operação, é necessário inseri-los através de uma planilha. Ela deve conter os seguintes campos obrigatórios:

                ul(
                    style='display: grid; grid-template-columns: 0.5fr 0.5fr 0.5fr 0.5fr; width: 100%'
                )
                    li Identificador da Operação
                    li Descrição
                    li Observação
                    li Cultura
                    li Safra
                    li Volume
                        el-tooltip
                            div(slot='content')
                                | As unidades de medida permitidas<br>para esta operação são:<br><br>
                                span(
                                    v-for='unidade in unidadesMedida',
                                    :key='unidade.codigo'
                                )
                                    | - {{ unidade.nome }} ({{ unidade.simbolo }})<br>
                            i.el-icon-info
                    li.nao_obrigatorio Valor (R$) (opcional)
                    li Nome Fornecedor
                    li Documento Fornecedor (CNPJ)
                    li Data do Contrato
                    li Vencimento
                    li.nao_obrigatorio Nome Armazém (opcional)
                    li.nao_obrigatorio Armazém Documento (opcional)

                p Dados do imóvel
                ul(
                    style='display: grid; grid-template-columns: 0.5fr 0.5fr 0.5fr 0.5fr; width: 100%'
                )
                    li Identificador da Operação
                    li CAR
                    li.nao_obrigatorio Nome do Imóvel (opcional)
                    li.nao_obrigatorio Nome Produtor (opcional)
                    li Documento Produtor (CPF/CNPJ)
                    li Volume Recebido
                    li.nao_obrigatorio Valor (R$) (opcional)

                footer
                    BaseButton(
                        plain,
                        icon='el-icon-download',
                        @click='baixarPlanilha'
                    ) Baixar modelo da planilha
                    el-upload.upload-demo(
                        action='#',
                        :auto-upload='false',
                        :on-change='validarPlanilha',
                        :limit='1',
                        ref='refUploadPlanilha'
                    )
                        BaseButton(
                            type='primary',
                            :icon='botaoInserirPlanilha.icone',
                            :disabled='botaoInserirPlanilha.desabilitado'
                        ) {{ botaoInserirPlanilha.texto }}

                .status(v-if='botaoInserirPlanilha.desabilitado')
                    span {{ statusCadastroPlanilha }}

        .nova-operacao-cda-wa__lista-operacoes.mt-20
            .nova-operacao-cda-wa__lista-operacoes__titulo
                h2.font-weight-bold Lista de operações
                BaseButton(
                    type='danger',
                    @click='limparLista',
                    :icon='limpandoLista ? "el-icon-loading" : "el-icon-delete"',
                    size='mini'
                ) Limpar lista

            el-card(:body-style='{ padding: "5px" }')
                el-table.table_nova_operacao(
                    :data='operacoes',
                    v-loading='buscandoOperacoes',
                    element-loading-text='Buscando operaçoes em cadastramento...'
                    @sort-change='sortChangeRequest'
                )
                    el-table-column(label='Identificador', width='105px')
                        .template(slot-scope='scope')
                            em.badge.badge-secondary {{ scope.row.identificador }}

                    el-table-column(label='Operação', minWidth='145px')
                        .template(slot-scope='scope')
                            span.column_text {{ scope.row.descricao }}

                    el-table-column(prop='safra', label='Safra')
                    el-table-column(prop='cultura', label='Cultura', sortable='custom', width='95')
                    el-table-column(prop='volumeContratado', label='Volume', sortable='custom', width='110')
                    el-table-column(prop='valor', label='Valor', sortable='custom', width='110')
                    el-table-column(
                        prop='fornecedorNome',
                        label='Fornecedor',
                        minWidth='100'
                    )
                    el-table-column(
                        prop='fornecedorDocumento',
                        label='Documento do fornecedor',
                        minWidth='125'
                    )
                    el-table-column(
                        prop='dataContrato',
                        label='Data do contrato',
                        sortable='custom',
                        minWidth='115'
                    )
                    el-table-column(
                        prop='dataVencimento',
                        label='Vencimento',
                        sortable='custom',
                        minWidth='125'
                    )
                    el-table-column(prop='observacao', label='Observação', width='150')
                    el-table-column(
                        prop='nomeArmazem',
                        label='Nome do armazém',
                        width='125'
                    )
                    el-table-column(
                        prop='documentoArmazem',
                        label='Documento do armazém',
                        width='125'
                    )

                    template(slot='empty')
                        el-empty(description='Sem dados')

                .nova-operacao-cda-wa__tabela-rodape
                    p {{ totalOperacoes }} {{ totalOperacoes === 1 ? 'operação' : 'operações' }}

                    el-pagination(
                        background,
                        :page-size='paginacao.size',
                        :current-page.sync='paginacao.page',
                        layout='prev, pager, next',
                        :total='totalOperacoes',
                        @current-change='alterarPagina'
                    )

            .nova-operacao-cda-wa__cadastrar-operacoes.mt-20
                BaseButton(
                    type='primary',
                    size='large',
                    :icon='cadastrandoOperacoes ? "el-icon-loading" : "el-icon-plus"',
                    :disabled='!totalOperacoes',
                    @click.native='cadastrarOperacoes'
                ) Enviar {{ totalOperacoes === 1 ? 'operação' : 'operações' }} para processamento
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import UnidadeMedidaService from '@/services/UnidadeMedidaService';

export default {
    name: 'novaOperacaoCdaWa',
    components: {
        BaseHeader,
        BaseButton
    },
    data() {
        return {
            operacoes: [],
            totalOperacoes: 0,
            buscandoOperacoes: false,
            paginacao: {
                page: 1,
                size: 10,
                sort: ''
            },
            order: null,
            nomeColumn: null,
            botaoInserirPlanilha: {
                texto: 'Inserir planilha',
                icone: 'el-icon-upload2',
                desabilitado: false
            },
            cadastrandoOperacoes: false,
            unidadesMedida: [],
            limpandoLista: false,
            statusCadastroPlanilha: ''
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    async mounted() {
        await this.buscarOperacoesEmCadastramento();
        await this.buscarUnidadesMedida();

        try {
            await connect();
        } catch {
            this.$notify.error({
                message:
                    'Não foi possível se conectar na api para realizar operações com a planilha'
            });
            return;
        }

        if (this.usuarioLogado) {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/planilha/insercao-em-lote/validada`,
                async response => {
                    const { status, hash } = JSON.parse(response);
                    if (status === 'VALIDO') this.processarPlanilha(hash);
                    else {
                        this.$notify.error({
                            message: 'A planilha inserida possui erros.'
                        });
                        this.baixarPlanilhaComErros(hash);
                    }
                }
            );

            subscribe(
                `${this.usuarioLogado.idKeyCloack}/planilha-cadastro-cda-wa/status`,
                async response => {
                    this.statusCadastroPlanilha = response;
                }
            );
        }
    },

    beforeDestroy() {
        disconnect();
        this.limparLista(false);
    },

    methods: {
        async buscarOperacoesEmCadastramento() {
            this.buscandoOperacoes = true;

            if (!this.order) {
                this.paginacao.sort = '&sort=data_cadastro,asc';
            }

            try {
                const { data } =
                    await OperacaoCdaWaService.buscarOperacoesEmCadastramento(
                        this.paginacao
                    );
                const { itens, totalItens } = JSON.parse(data);

                this.operacoes = itens;
                this.totalOperacoes = totalItens;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar as operações.'
                });
            } finally {
                this.buscandoOperacoes = false;
            }
        },

        alterarPagina(pagina) {
            this.paginacao.page = pagina;
            this.buscarOperacoesEmCadastramento();
        },

        async validarPlanilha(planilha) {
            this.botaoInserirPlanilha.desabilitado = true;
            this.botaoInserirPlanilha.texto = 'Validando planilha';
            this.botaoInserirPlanilha.icone = 'el-icon-loading';

            if (planilha.name.split('.').pop().toLowerCase() !== 'xlsx') {
                this.$notify.error({
                    message:
                        'Apenas arquivos com a extensão XLSX são suportados.'
                });
                this.$refs.refUploadPlanilha.clearFiles();

                this.botaoInserirPlanilha.desabilitado = false;
                this.botaoInserirPlanilha.texto = 'Inserir planilha';
                this.botaoInserirPlanilha.icone = 'el-icon-upload2';

                return false;
            }

            try {
                await OperacaoCdaWaService.validarPlanilha(planilha);
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar upload do arquivo.'
                });
                this.botaoInserirPlanilha.desabilitado = false;
                this.botaoInserirPlanilha.texto = 'Inserir planilha';
                this.botaoInserirPlanilha.icone = 'el-icon-upload2';
            }
            this.$refs.refUploadPlanilha.clearFiles();
        },

        async processarPlanilha(hash) {
            try {
                if (this.usuarioLogado) {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/planilha/insercao-em-lote/processada`,
                        async response => {
                            if (response.startsWith('Erro')) {
                                this.$notify.error({
                                    message: 'Erro ao processar a planilha.'
                                });
                            } else {
                                this.$notify.success({
                                    message: response
                                });
                            }

                            this.botaoInserirPlanilha.desabilitado = false;
                            this.botaoInserirPlanilha.texto =
                                'Inserir planilha';
                            this.botaoInserirPlanilha.icone = 'el-icon-upload2';

                            await this.buscarOperacoesEmCadastramento();
                        }
                    );
                }
                this.botaoInserirPlanilha.texto = 'Cadastrando planilha';
                await OperacaoCdaWaService.processarPlanilha({
                    hash
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao processar a planilha.'
                });
                this.botaoInserirPlanilha.desabilitado = false;
                this.botaoInserirPlanilha.texto = 'Inserir planilha';
                this.botaoInserirPlanilha.icone = 'el-icon-upload2';
            }
        },

        async baixarPlanilhaComErros(hash) {
            this.botaoInserirPlanilha.texto = 'Baixando planilha com erros';
            this.botaoInserirPlanilha.icone = 'el-icon-loading';

            try {
                await OperacaoCdaWaService.baixarPlanilhaComErros({
                    hash
                });
                this.botaoInserirPlanilha.desabilitado = false;
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar download da planilha.'
                });
            }
            this.botaoInserirPlanilha.desabilitado = false;
            this.botaoInserirPlanilha.texto = 'Inserir planilha';
            this.botaoInserirPlanilha.icone = 'el-icon-upload2';
        },

        async cadastrarOperacoes() {
            this.cadastrandoOperacoes = true;

            try {
                await OperacaoCdaWaService.cadastrarOperacoes();

                this.$notify.success({
                    message: 'Operações cadastradas com sucesso.'
                });

                this.$router.push({ name: 'OperacoesCdaWa' });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao cadastrar operações.'
                });
            } finally {
                this.cadastrandoOperacoes = false;
            }
        },

        async baixarPlanilha() {
            await OperacaoCdaWaService.downloadPlanilhaModelo()
                .then(() => {
                    this.$notify.success({
                        message: 'Download realizado com sucesso!'
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: 'Erro ao realizar download!'
                    })
                );
        },

        async buscarUnidadesMedida() {
            const compararPorNome = (a, b) => {
                if (a.nome < b.nome) return -1;
                if (a.nome > b.nome) return 1;
                return 0;
            };

            try {
                const { data } = await UnidadeMedidaService.buscarTodas();
                this.unidadesMedida = JSON.parse(data).sort(compararPorNome);
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar as unidades de medida.'
                });
            }
        },

        async limparLista(recarregar = true) {
            this.limpandoLista = true;

            try {
                await OperacaoCdaWaService.limparCadastramento();
                if (recarregar) this.buscarOperacoesEmCadastramento();
            } catch (error) {
                if (recarregar) {
                    this.$notify.error({
                        message: 'Não foi possível limpar a lista.'
                    });
                }
            } finally {
                this.limpandoLista = false;
            }
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }

            this.nomeColumn = column.prop;
            this.fetchOperacoes();
        },

        async fetchOperacoes() {
            let filtro = this.getFiltros();
            this.paginacao.sort = filtro.order;

            this.buscarOperacoesEmCadastramento();
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.size;
            filtro.page = this.paginacao.page - 1;

            filtro.order = '&sort=nome_cultura,asc';

            if (this.order && this.nomeColumn) {
                const nomesColunas = {
                    cultura: 'nome_cultura',
                    volumeContratado: 'volume_contratado',
                    valor: 'valor',
                    dataVencimento: 'data_vencimento',
                    dataContrato: 'data_contrato'
                };
                const sort = nomesColunas[this.nomeColumn];
                filtro.order = `&sort=${sort},${this.order}`;
            }
            return filtro;
        }
    }
};
</script>

<style lang="scss">
#nova-operacao-cda-wa {
    .nova-operacao-cda-wa__preenchimento-em-massa {
        transition: all .5s linear;

        h2 {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 5px;
        }

        ul {
            width: 700px;
            column-count: 3;

            li {
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 19.6px;
            }

            li::after {
                content: '*';
                color: red;
                font-weight: bolder;
                margin-right: 2px;
            }
        }

        footer {
            display: flex;
            justify-content: space-between;
            height: 40px;
            overflow: hidden;

            .el-upload {
                display: flex;
                justify-content: flex-end;
            }

            .upload-demo {
                max-width: 153px !important;
            }
        }

        .status {
            margin-top: 20px;
            font-weight: bold;
            color: grey;
            text-align: center;
        }
    }

    .nova-operacao-cda-wa__lista-operacoes {
        margin-bottom: 20px;

        .cell {
            word-break: normal;
        }

        .nova-operacao-cda-wa__lista-operacoes__titulo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4px;

            h2 {
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 10px;
            }
        }

        em.nova-operacao-cda-wa__lista-operacoes__identificador {
            font-style: normal;
            background-color: var(--secondary);
            padding: 2px 4px;
            border-radius: 4px;
            font-weight: 600;
            color: black !important;
        }

        .nova-operacao-cda-wa__tabela-rodape {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 44% 5px 10px;

            p {
                font-weight: bold;
                color: var(--primary);
                margin: 0;
            }
        }

        .nova-operacao-cda-wa__cadastrar-operacoes {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;
        }

        .table_nova_operacao {
            width: 2000px !important;
        }
    }

    .mt-20 {
        margin-top: 20px;
    }

    .nao_obrigatorio::after {
        content: '' !important;
    }

    .badge.badge-secondary {
        white-space: normal !important;
        word-break: normal;
    }
}
</style>
